import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'de',
  fallbackLocale: 'de',
  messages: { }
})

const loadedLanguages = []

function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync(lang, callback) {
  
  if (loadedLanguages.includes(lang)) {
    if (i18n.locale !== lang) setI18nLanguage(lang)
    return Promise.resolve()
  }

  let formData = new FormData()
  formData.set('action', 'get_translation')
  axios.post(window.location.origin+'/wp-admin/admin-ajax.php', formData)
    .then(res => {
      let msgs = res.data.translation
      loadedLanguages.push(lang)
      i18n.setLocaleMessage(lang, msgs)
      setI18nLanguage(lang)

      if(callback)
        callback()
    })
    .catch(err => console.log(err))

  if (lang !== 'de' && !loadedLanguages.includes('de')) {
    let formDataFallback = new FormData()
    formDataFallback.set('action', 'get_fallbacktranslation')
    axios.post(window.location.origin+'/wp-admin/admin-ajax.php', formDataFallback)
      .then(res => {
        loadedLanguages.push('de')
        i18n.setLocaleMessage('de', res.data.fallback)
      })
      .catch(err => console.log(err))
  }
}